// Module
var code = `<ul class="card-holder">
  <li></li>
  <li class="shape"></li>
  <li class="color"></li>
  <li class="shape color"></li>
</ul>

<div class="buttons">
  <button data-type="adapt" data-method="add">ADD COLOR</button>
  <button data-type="adapt" data-method="remove">REMOVE COLOR</button>
  <button data-type="adapt" data-method="toggle">TOGGLE SHAPE</button>
  <button data-type="adapt" data-method="reset">RESET</button>
</div>
`;
// Exports
module.exports = code;